// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment} from 'react';
import {Faq_question} from '../products/faq_question';
import {use_download} from '../shared/use_download';
import {On_scroll_animation} from '../shared/on_scroll_animation';
import {Editor} from '../../../shared/editor/editor';
import styles from './browser_faq.module.less';

export const Browser_faq = ()=>{
    const {download_br} = use_download();
    const on_download = ()=>{
        download_br({cb: ()=>{
          // waiting for iframe to start actial downloading
          setTimeout(()=>{
              // absolute link for holabrowser.com
              window.location.href =
                  'https://hola.org/after_download?s=install&browser=1';
          }, 1000);
        }});
    };
    return <div className={styles.faq}>
      <div className={styles.faq_content}>
        <div className={styles.faq_column}>
          <h3>Common questions people ask</h3>
          <Faq_question quest="How do I install Hola Browser?"
            ans={<Fragment>
              To install Hola browser, simply download
              the <a href="#" onClick={on_download}>installation file</a>,
              then look for it in your downloads folder. Open the file and
              follow the instructions.
            </Fragment>}/>
          <Faq_question
            quest="Can I use the Hola Browser for free?"
            ans={<Fragment>
              Absolutely! At Hola, we are committed to democratizing access
              to online content. Both our free and <a
              href="https://hola.org/premium?ref=from_faq_browser_product">Premium
              </a> versions are designed to provide you with access to
              worldwide content, regardless of your location. The free
              version allows you to enjoy Hola VPN without any cost but
              with some time limits. However, for those seeking additional
              benefits, such as unlimited VPN time, usage on multiple
              devices, HD streaming, enhanced performance and more, you can
              choose to upgrade to our <a
              href="https://hola.org/premium?ref=from_faq_browser_product">Premium
              </a> version at any time.
              </Fragment>}/>
          <Faq_question
            quest="Why do I need Hola Browser?"
            ans={<Fragment>
              The greatest thing about the Hola Browser is that it has a VPN
              built into it, which is super convenient. It`s also super
              simple to download and start using. Many websites and online
              services restrict access based on your location. A VPN allows
              you to connect to peers or servers in different regions and
              countries, enabling you to access content from around
              the world.
            </Fragment>}/>
          <Faq_question quest="Can I make Hola my default browser?"
            ans={<Fragment>
              You can set Hola as your default browser on Windows or Mac
              operating systems.. When you set Hola as your default browser,
              any link you click will automatically open in the Hola browser.
            </Fragment>}/>
        </div>
        <div className={styles.faq_smiles}>
          <On_scroll_animation
            src={`animation/support_product.json`} size={[440, 320]}
            animation={[{frames: {from: 50, to: 75}, direction: 1,
              loop: false}]}
            cls={styles.faq_lottie} scroll_to_pos={0.05}/>
        </div>
      </div>
    </div>;
};

interface i_browser_faq_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Browser_faq_editor = (
{value, on_change}: i_browser_faq_editor_props)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
